export const UNIT_STATUS = {
  occupied: ['Occupied', 'ok'],
  leased: ['Lease signed', 'info'],
  vacant: ['Vacant', 'warn'],
  notice: ['Notice given', 'bad']
};

const PENDING = ['Draft', 'Under Application / Prospect'];

export function unitStatus(l) {
  if (l.tenantId || l.tenantName) {
    if (l.tenantStatus === 'Active - Notice Given') return 'notice';
    if (PENDING.includes(l.tenantStatus)) return 'leased';
    return 'occupied';
  }
  return l.status === 'leased' ? 'leased' : 'vacant';
}

export const isVacant = (l) => ['vacant', 'notice'].includes(unitStatus(l));

const COMMERCIAL = ['commercial', 'office', 'retail', 'warehouse', 'industrial', 'mobile_home_lot'];

export const isCommercial = (l) => l.use === 'commercial' || COMMERCIAL.includes(l.unitType);

export const prospectsFor = (prospects, name) =>
  prospects.filter((p) => String(p.interestedProperty || '').trim().toLowerCase() === String(name || '').trim().toLowerCase());

export function ownerRows(units) {
  const by = new Map();
  units.forEach((u) => {
    const key = u.ownerName || 'No owner on file';
    const o = by.get(key) || { name: key, ownerId: u.ownerId || null, units: 0, vacant: 0, rent: 0, work: 0 };
    o.units += 1;
    if (isVacant(u)) o.vacant += 1;
    else o.rent += Number(u.rent) || 0;
    o.work += u.work?.openTickets || 0;
    by.set(key, o);
  });
  return [...by.values()].sort((a, b) => b.units - a.units || a.name.localeCompare(b.name));
}
